export const APP_VERSION = "11.12.2-rc.838";
